import React, {useState} from 'react'
import {PROFILE_FIELD, STEPS} from '../../core/_const'
import {Button, InputTextFormik} from '../../../../../_gori/partials/widgets'
import {isEmpty} from 'lodash'
import {KTSVG} from '../../../../../_gori/helpers'
import {useIntl} from 'react-intl'
import {CSSTransition} from 'react-transition-group'
import clsx from 'clsx'
import SettingsService from '../../../settings/core/_requests'
import {ComparePlanFeatures, Tiers} from '../../../common'

type Props = {
  setActiveStep: any
  formik: any
  currentTier: any
  setCurrentTier: any
  setSaveAndExit: any
}
const Pricing: React.FC<Props> = ({
  setActiveStep,
  formik,
  currentTier,
  setCurrentTier,
  setSaveAndExit,
}) => {
  const intl = useIntl()
  const [promoCode, setPromoCode] = useState('')
  const [isApplyingPromo, setIsApplyingPromo] = useState(false)
  const [promoError, setPromoError] = useState('')
  const [promoSuccess, setPromoSuccess] = useState(false)

  const handleApply = async () => {
    if (!promoCode.trim()) {
      setPromoError(intl.formatMessage({id: 'PROMO_CODE_REQUIRED'}))
      return
    }

    try {
      setIsApplyingPromo(true)
      setPromoError('')
      const response = await SettingsService.applyPromoCode({promo_code: promoCode})
      if (response) {
        setPromoCode('')
        setPromoSuccess(true)
      }
    } catch (error: any) {
      const errorMessage = error?.response?.data?.error?.message || ''
      setPromoError(intl.formatMessage({id: errorMessage}))
    } finally {
      setIsApplyingPromo(false)
    }
  }

  const handleInputChange = (e) => {
    setPromoCode(e.target.value)
    if (promoError) setPromoError('')
    if (promoSuccess) setPromoSuccess(false)
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleApply()
    }
  }

  const handleContinue = () => {
    setSaveAndExit(false)
    setActiveStep(STEPS.single_step)
  }

  return (
    <>
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <>
          <div className='pricing-step-wrapper d-flex justify-content-center align-items-center my-9'>
            <div className='w-100 pricing-step-card'>
              <div className='pricing-step-card__body'>
                <div className='pricing-plans pricing-page-container container'>
                  <div className='col-md-12 bg-white rounded-3 rounded-bottom-0'>
                    <div className='text-start fs-1 fw-bolder text-black px-10 py-5 border-bottom'>
                      {intl.formatMessage({id: 'SELECT_PLAN'})}
                    </div>
                  </div>
                  <div className='bg-white col-10 container my-10'>
                    <div className='row d-flex justify-content-between my-0'>
                      <Tiers
                        page='onboarding'
                        currentTier={currentTier}
                        setCurrentTier={setCurrentTier}
                        showPopularFlag={true}
                      />
                      <ComparePlanFeatures page='onboarding' />
                    </div>
                  </div>
                </div>

                <div className='col-md-10 sales-rep container'>
                  <div className='p-10 bg-white'>
                    <div className='row'>
                      {PROFILE_FIELD.SALES.map((field, index) => {
                        if (field.type === 'text' && field.name !== 'promo_code') {
                          return (
                            <div className='col-md-12' key={index}>
                              <InputTextFormik
                                className='col-12 col-md-3'
                                formik={formik}
                                name={field.name}
                                disabled={formik.isSubmitting || field.disabled}
                                label={
                                  <>
                                    {intl.formatMessage({id: field.label})}
                                    {!field.required && (
                                      <i className='ms-2 text-muted fs-7'>
                                        {intl.formatMessage({id: 'OPTIONAL_LABEL'})}
                                      </i>
                                    )}
                                  </>
                                }
                                labelClassName={clsx('fw-bolder', {required: field.required})}
                              />
                            </div>
                          )
                        }
                        return null
                      })}
                    </div>

                    <div className='row mt-6'>
                      <div className='col-md-12'>
                        <label className='form-label fw-bolder'>
                          {intl.formatMessage({id: 'PROMO_CODE'})}
                          <i className='ms-2 text-muted fs-7'>
                            {intl.formatMessage({id: 'OPTIONAL_LABEL'})}
                          </i>
                        </label>
                        <div className='d-flex align-items-center gap-2 col-8 col-md-3'>
                          <input
                            type='text'
                            autoComplete='off'
                            name='promo-code'
                            value={promoCode}
                            onChange={handleInputChange}
                            onKeyPress={handleKeyPress}
                            placeholder='Enter code'
                            className='form-control'
                            style={{
                              borderColor: promoError ? '#dc3545' : '#E4E6EF',
                            }}
                          />
                          <button
                            onClick={handleApply}
                            disabled={isApplyingPromo}
                            type='button'
                            className='btn btn-advanced-primary'
                            style={{minWidth: '80px'}}
                          >
                            {isApplyingPromo && (
                              <span
                                className='spinner-border spinner-border-sm me-2'
                                role='status'
                              ></span>
                            )}
                            {isApplyingPromo
                              ? intl.formatMessage({id: 'APPLYING'})
                              : intl.formatMessage({id: 'APPLY'})}
                          </button>
                        </div>
                        {(promoError || promoSuccess) && (
                          <div className='mt-2'>
                            {promoError && (
                              <div
                                className='text-danger d-flex align-items-center gap-1'
                                style={{fontSize: '12px'}}
                              >
                                <KTSVG
                                  path='/media/gori/promotions/exclamation.svg'
                                  className='flex-shrink-0'
                                  style={{width: '16px', height: '16px'}}
                                />
                                {promoError}
                              </div>
                            )}
                            {promoSuccess && (
                              <div
                                className='text-success d-flex align-items-center gap-1'
                                style={{fontSize: '12px'}}
                              >
                                <KTSVG
                                  path='/media/gori/landing/teal-check.svg'
                                  className='flex-shrink-0'
                                  style={{width: '16px', height: '16px'}}
                                />
                                {intl.formatMessage({id: 'PROMO_CODE_APPLIED'})}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='px-5 py-5 bg-white rounded-3 rounded-top-0 border-top'>
                  <div className='d-flex justify-content-end container'>
                    <Button
                      className='btn btn-advanced-primary'
                      label={intl.formatMessage({id: 'CONTINUE_TO_BUSINESS_PROFILE'})}
                      loadingText={intl.formatMessage({id: 'CONTINUE_TO_BUSINESS_PROFILE'})}
                      loading={formik.isSubmitting}
                      event={handleContinue}
                      disabled={formik.isSubmitting || !isEmpty(formik.errors)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </CSSTransition>
    </>
  )
}

export {Pricing}
